import { render } from "./TodoView.vue?vue&type=template&id=b44bf1a4"
import script from "./TodoView.vue?vue&type=script&lang=js"
export * from "./TodoView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__